import { useQuery } from '@tanstack/react-query';
import { searchKeys } from './queryKeys';
import { searchContent, type SearchResponse } from '../lib/api/search';

const MIN_QUERY_LENGTH = 2;

/**
 * Library search hook. `query` is expected to be already-debounced upstream
 * (typically via useDebounce(rawQuery, 200)).
 *
 * Disabled for empty queries OR queries shorter than `MIN_QUERY_LENGTH` so
 * we don't fire FTS for single-char or empty input — keeps the request
 * count low and matches the empty-state UI's threshold.
 *
 * 5-minute stale time + no refetch-on-focus mirrors the project's existing
 * query config from services/api.ts.
 */
export function useSearch(query: string, limit = 8) {
  const trimmed = query.trim();
  const enabled = trimmed.length >= MIN_QUERY_LENGTH;
  return useQuery<SearchResponse>({
    queryKey: searchKeys.byQuery(trimmed, limit),
    queryFn: () => searchContent(trimmed, limit),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
